import React from 'react';
import { Popover, Tooltip } from 'antd';
import ExportLog from '@/components/ExportLog';
import downLoad from '@/assets/images/icon_download.svg';

const Download = ({ showLogListDot, exportLogList, logListLoading, setLogListDot, getLogList }) => {
  const handleExportLog = (visible) => {
    if (visible) {
      setLogListDot(false);
      getLogList();
    }
  };
  return (
    <Popover
      overlayClassName="export-log"
      trigger="click"
      placement="topRight"
      arrowPointAtCenter
      onVisibleChange={handleExportLog}
      getPopupContainer={(trigger) => trigger.parentNode}
      title={<div style={{ fontSize: '14px', textAlign: 'left' }}>下载</div>}
      content={<ExportLog data={exportLogList} loading={logListLoading} />}
    >
      <div className="download">
        <Tooltip placement="bottom" title="下载">
          <img src={downLoad} className="download-img" alt="下载" />
        </Tooltip>
        <span
          className="download-dot"
          style={{ display: showLogListDot ? 'inline-block' : 'none' }}
        />
      </div>
    </Popover>
  );
};

export default Download;
